// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"4b0d5a34","272":"97b7359d","481":"42b1374d","488":"e41ac3e0","758":"8cdcd0bc","898":"2c2c499a","962":"73980eb0"}[chunkId] + ".chunk.js";
};